import { APIClient } from "../../../../api/api_helper";
import { GetUserData } from "../../../../common/service/CommonService";
import { Admin_API } from "../../../../api/url_helper";
/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface CurrentUser {
  userid: number;
}

interface UserPayload {
  userid?: number | null;
  userassignmentid?: number | null;
  roleid?: number | null;
  username?: string;
  userdisplayname?: string;
  useremail?: string;
  rolename?: string;
  description?: string;
  createdby?: number;
  updatedby?: number;
  updatereason?: string | null;
  contactnumber?: string;
}

/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * ROLE API
 * ------------------------------------------------------------------ */

export const userApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      status: "A",
      searchtext: searchText ?? "",
      pagenumber: pageNumber,
      pagesize: pageSize,
    };
    return api.create(Admin_API.User_API + "SelectAll", payload);
  },

  // INSERT METHOD
  insertData: (payload_data: UserPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      userid: payload_data.userid,
      roleid: payload_data.roleid,
      updatedby: user?.userid,
    };
    return api.create(Admin_API.UserRoleAssign_API + "Insert", payload);
  },

  // UPDATE METHOD
  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      userid: payload_data.userid,
      username: payload_data.username,
      firstname: payload_data.firstname,
      lastname: payload_data.lastname,
      userpassword: payload_data.userpassword || null,
      useremail: payload_data.useremail,
      contactnumber: payload_data.contactnumber,
      updatereason: payload_data.updatereason,
      updatedby: user?.userid,
    };
    return api.create(Admin_API.User_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: { userid: number | null; updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      userid: payload_data.userid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid
    };
    return api.create(Admin_API.User_API + "Delete", payload);
  },

  // ---------------------------------------------------------------------------------------------
  // User DROPDOWN METHOD
  getUserDropdownData: () => {
    const payload = {
      status: "A",
    };
    return api.create(Admin_API.User_API + "Dropdown", payload);
  },

  // Role DROPDOWN METHOD
  getRoleDropdownData: () => {
    const payload = {
      status: "A",
    };
    return api.create(Admin_API.Role_API + "Dropdown", payload);
  },

  // INSERT USER METHOD
  insertUser: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      username: payload_data.username,
      firstname: payload_data.firstname,
      lastname: payload_data.lastname,
      userpassword: payload_data.userpassword,
      useremail: payload_data.useremail,
      contactnumber: payload_data.contactnumber,
      createdby: user?.userid,
    };
    return api.create(Admin_API.User_API + "Insert", payload);
  },

};
